"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondStrikeAbilityHandler = exports.SecondStrikeActorAbilityFactory = exports.SecondStrikeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const Damage_1 = require("../../core/Damage");
class SecondStrikeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SecondStrike;
        this.__typeName = "SecondStrike";
    }
}
exports.SecondStrikeAbilityArgs = SecondStrikeAbilityArgs;
let SecondStrikeActorAbilityFactory = class SecondStrikeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SecondStrike", "Self", 0);
    }
};
SecondStrikeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SecondStrike")
], SecondStrikeActorAbilityFactory);
exports.SecondStrikeActorAbilityFactory = SecondStrikeActorAbilityFactory;
let SecondStrikeAbilityHandler = class SecondStrikeAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            effect: new __1.DamageReciprocateEffectArgs(new Damage_1.Damage(__1.DamageType.Physical, 5 * container.getLevel(actorId))),
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
SecondStrikeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SecondStrike)
], SecondStrikeAbilityHandler);
exports.SecondStrikeAbilityHandler = SecondStrikeAbilityHandler;
